export const historyConstants = {
  TRANSACTION_HISTORY_LIST_REQUEST: "TRANSACTION_HISTORY_LIST_REQUEST",
  TRANSACTION_HISTORY_LIST_COMPLETE: "TRANSACTION_HISTORY_LIST_COMPLETE",

  TRANSACTION_HISTORY_DETAIL_REQUEST: "TRANSACTION_HISTORY_DETAIL_REQUEST",
  TRANSACTION_HISTORY_DETAIL_COMPLETE: "TRANSACTION_HISTORY_DETAIL_COMPLETE",
  TRANSACTION_HISTORY_DETAIL_ERROR: "TRANSACTION_HISTORY_DETAIL_ERROR",

  TRANSACTION_HISTORY_DETAIL_REMOVE: "TRANSACTION_HISTORY_DETAIL_REMOVE",

  TRANSACTION_TYPE_ALL: "ALL",

  TRANSACTION_TYPES: [
    {
      value: "ALL",
      label: "All Transactions",
    },
    {
      value: "TRANSFER",
      label: "Fund Transfer",
    },
    {
      value: "BILLER",
      label: "Bill Payment",
    },
  ],
};
